import React, { useState } from "react";
import "../Announcement/Announcement.css";
import AnnouncementFormComponent, {
  ANNOUNCEMENT_TYPE_HADITH,
} from "../../../Components/AnnouncementComponent/AnnouncementFormComponent/AnnouncementFormComponent";
import AnnouncementCarouselComponent from "../../../Components/AnnouncementComponent/AnnouncementCarouselComponent/AnnouncementCarouselComponent";
import { useAppSelector } from "../../../Redux/hooks";
import PageContainer from "../../Shared/PageContainer/PageContainer";

const Hadith = () => {
  const sidebarState = useAppSelector((state) => state.sidebarState);
  const [ViewingHadith, setViewingHadith] = useState(false);

  return (
    <>
      <PageContainer title={"Hadith"}>
        <div className="RightAnnouncementContainer">
          {ViewingHadith ? (
            <>
              <AnnouncementCarouselComponent
                setViewingAnnouncement={setViewingHadith}
                type={ANNOUNCEMENT_TYPE_HADITH}
                label="Hadith"
              />
            </>
          ) : (
            <>
              <AnnouncementFormComponent
                setViewingAnnouncement={setViewingHadith}
                type={ANNOUNCEMENT_TYPE_HADITH}
                label="Hadith"
              />
            </>
          )}
        </div>
      </PageContainer>
    </>
  );
};

export default Hadith;
